import React from "react"
import { Box, Flex, Text } from "@chakra-ui/react"
import { ResultPaginationNextPrevProps, ResultStateProvider } from "@usereactify/search"

import { colors } from "@app/theme/colors"

import Icon from "@components/Icon"

export type Props = { pageSize?: number } & React.ComponentProps<NonNullable<ResultPaginationNextPrevProps["render"]>>

export const Pagination: React.FC<Props> = props => {
  const scrollToProductGrid = () => {
    // document.getElementById("reactify-search-product-grid-anchor")?.scrollIntoView()
    document.getElementById("purebaby-header")?.scrollIntoView()
  }

  return (
    <Flex pt={3} flexDirection={"column"} alignItems={"center"}>
      <Flex alignItems={"center"} justifyContent={"center"}>
        <Flex
          mr={[1, 2]}
          justifyContent={"center"}
          alignItems={"center"}
          borderRadius={"999px"}
          width={"48px"}
          height="48px"
          bg={props.hasPreviousPage ? colors.brand.navy.light : colors.brand.divider}
          cursor="pointer"
          onClick={() => {
            scrollToProductGrid()
            props.handlePreviousPage()
          }}
        >
          <Icon name="arrowLeft" size={"22px"} color={props.hasPreviousPage ? colors.white : colors.brand.border} />
        </Flex>
        <Flex>
          {props.pagesToShow.map((page, idx) => {
            return (
              <Box
                cursor="pointer"
                textDecoration={props.currentPage === page ? "underline" : ""}
                fontWeight={props.currentPage === page ? "bold" : ""}
                key={idx}
                mx={[1, 2]}
                onClick={() => {
                  scrollToProductGrid()
                  props.handlePageChange(page)
                }}
              >
                {page + 1}
              </Box>
            )
          })}
        </Flex>
        <Flex
          ml={[1, 2]}
          justifyContent={"center"}
          alignItems={"center"}
          borderRadius={"999px"}
          width={"48px"}
          height="48px"
          cursor="pointer"
          bg={props.hasNextPage ? colors.brand.navy.light : colors.brand.divider}
          onClick={() => {
            scrollToProductGrid()
            props.handleNextPage()
          }}
        >
          <Icon name="arrowRight" size={"22px"} color={props.hasNextPage ? colors.white : colors.brand.border} />
        </Flex>
      </Flex>
      <Flex mt={3}>
        <ResultStateProvider
          render={state => {
            return (
              <Text size="md" color={colors.text.secondary}>
                Showing{" "}
                {props.actualCurrentPage * props.pageSize > state.hits.total ? state.hits.total : props.actualCurrentPage * props.pageSize}{" "}
                of {state?.hits?.total || 0} Results
              </Text>
            )
          }}
        ></ResultStateProvider>
      </Flex>
    </Flex>
  )
}
